import { CustomerTypes } from "./enums/CustomerTypes";

export const LOOKUP_COMPANY_NAME_LIMIT = 45;
export const LOOKUP_COMPANY_NAME_LIMIT_MODAL = 40;
export const LOOKUP_COMPANY_DESC_LIMIT_MODAL = 57;
export const HAS_PHONE_FIELD = [CustomerTypes.CONTRACTOR, CustomerTypes.STAFF];
export const HAS_REPORTS_TO_FIELD = [CustomerTypes.CONTRACTOR, CustomerTypes.STAFF];
export const HAS_STANDS_WORKINGON_FIELD = [CustomerTypes.CONTRACTOR, CustomerTypes.STAFF];
export const HAS_COMPANY_NAME_FIELD = [CustomerTypes.CONTRACTOR, CustomerTypes.STAFF];
export const HAS_COMPANY_ADDRESS_FIELD = [CustomerTypes.CONTRACTOR, CustomerTypes.STAFF];
export const NOT_ENOUGH_ENTITLEMENTS_ERROR = 'NotEnoughAvailableEntitlementsForChildAllocation';

export const MAX_MATCHES_FOR_ONE_PAGE = 5
export const MIN_MATCHES_FOR_PAGINATION = 5;

